import { Injectable } from '@angular/core';
import { Http,Response , Headers } from '@angular/http';
import { Config } from '../../../config/config';
import { VnptHttpService } from '../../services/vnpt-http.service';
import { Observable }     from 'rxjs/Observable';
import { DMLoaiThietBi,SearchLoaiThietBi } from './dm-loai-thiet-bi';
@Injectable()
export class DMLoaiThietBiService {

    controller:string = 'DM_LoaiThietBi';
    constructor(private http: Http) { }
       
    GetList(keyword: string) {
        let headers = new Headers();       
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {};
        return this.http.get(Config.apiUrl + this.controller+'/GetList?keyword='+keyword, { headers: headers }).map(resp => resp.json());               
    }
    GetListAll() {
        let headers = new Headers();       
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {};
        return this.http.get(Config.apiUrl + this.controller+'/GetListAll', { headers: headers }).map(resp => resp.json());               
    }
    GetTree() {
        let headers = new Headers();       
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {};
        return this.http.get(Config.apiUrl + this.controller+'/Tree', { headers: headers }).map(resp => resp.json());
    }

    GetListFromPagination(paging:number,maxSize:number, keyword: string) {
        let headers = new Headers();
        let currentPage = paging - 1;
       
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.get(Config.apiUrl +this.controller+ "/GetList?currentPage="+ currentPage+"&maxSize="+ maxSize + "&keyword=" + keyword, { headers: headers }).map(resp => resp.json());       
    }
    Save(item:DMLoaiThietBi, file) {
        let headers = new Headers();
        //headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let formData = new FormData();
        formData.append("data", JSON.stringify(item));
        if (file)
            formData.append("anh", file, file.name);

        return this.http.post(Config.apiUrl + this.controller+'/save', formData, { headers: headers }).map(resp => resp.json());
    }
    Delete(id) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {
            Id: id
        };
        return this.http.post(Config.apiUrl + this.controller+'/delete', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    KiemTra_CapCha(LTB) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = LTB;
        return this.http.post(Config.apiUrl + 'DM_LoaiThietBi/KiemTraCapCha', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/thiet-bi/dm-loai-thiet-bi/dm-loai-thiet-bi.service.ts